import { group } from 'console';
import {fabric} from 'fabric'
export function makeGroup(canvas,selectedObjects) {
     var alltogetherObj = new fabric.Group([...selectedObjects],{left:selectedObjects[0].left+275,top:selectedObjects[0].top+250});
     alltogetherObj.setCoords(); 
    selectedObjects.forEach(function(obj){
        canvas.remove(obj);
    });
    canvas.add(alltogetherObj);
    
    canvas.renderAll();

}